import { render } from "./detail.vue?vue&type=template&id=72f4cf58&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=72f4cf58&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f4cf58"]])

export default __exports__